import { render, staticRenderFns } from "./UiQuickActions.vue?vue&type=template&id=ded4c7f6&"
import script from "./UiQuickActions.vue?vue&type=script&lang=js&"
export * from "./UiQuickActions.vue?vue&type=script&lang=js&"
import style0 from "./UiQuickActions.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
